module.exports = __webpack_public_path__ + "static/media/events12.77a8912d.png";